// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AzureIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#azure_svga)">
      <path
        fill="url(#azure_svgb)"
        d="M8 .7h7.1L7.73 22.53a1.1 1.1 0 0 1-1.07.77H1.13a1.13 1.13 0 0 1-1.07-1.5L6.93 1.47A1.1 1.1 0 0 1 8 .7"
      />
      <path
        fill="#0078D4"
        d="M18.32 15.34H7.06a.52.52 0 0 0-.36.9L13.94 23q.33.3.78.3h6.37z"
      />
      <path
        fill="url(#azure_svgc)"
        d="M8 .7a1.1 1.1 0 0 0-1.07.78L.07 21.8a1.13 1.13 0 0 0 1.06 1.5H6.8a1.2 1.2 0 0 0 .93-.78l1.37-4.03L14 23.04q.31.26.72.27h6.36l-2.8-7.97h-8.11L15.13.7z"
      />
      <path
        fill="url(#azure_svgd)"
        d="M17.07 1.46A1.1 1.1 0 0 0 16 .7H8.1a1.1 1.1 0 0 1 1.07.77l6.87 20.35a1.13 1.13 0 0 1-1.08 1.5h7.92a1.13 1.13 0 0 0 1.07-1.5z"
      />
    </g>
    <defs>
      <linearGradient
        id="azure_svgb"
        x1={10.59}
        x2={3.21}
        y1={2.37}
        y2={24.16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#114A8B" />
        <stop offset={1} stopColor="#0669BC" />
      </linearGradient>
      <linearGradient
        id="azure_svgc"
        x1={12.89}
        x2={11.19}
        y1={12.52}
        y2={13.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0.3} />
        <stop offset={0.07} stopOpacity={0.2} />
        <stop offset={0.32} stopOpacity={0.1} />
        <stop offset={0.62} stopOpacity={0.05} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="azure_svgd"
        x1={11.96}
        x2={20.05}
        y1={1.73}
        y2={23.3}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3CCBF4" />
        <stop offset={1} stopColor="#2892DF" />
      </linearGradient>
      <clipPath id="azure_svga">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>,
  "Azure",
);
export default AzureIcon;
